export default "__VITE_ASSET__zs3oRNYi__"